export const getExperienceRange = (
  minExperience: number,
  maximumExperience: number,
): string => {
  if (minExperience && maximumExperience) {
    return `Exp: ${minExperience}-${maximumExperience} Years`;
  } else {
    return `Fresher`;
  }
};
